import { render, staticRenderFns } from "./AddSeckillDialog.vue?vue&type=template&id=3f723a56&scoped=true&"
import script from "./AddSeckillDialog.vue?vue&type=script&lang=js&"
export * from "./AddSeckillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f723a56",
  null
  
)

export default component.exports